// extracted by mini-css-extract-plugin
module.exports = {"value":"NPd3jqOkcWCCe2gT","group":"_2jMEzhzKbiFgQVZu","flag":"_2rJgc2IXp6Ic5juU"};